(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9422],{

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 99071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-12faqix-0"
})(["border:1px solid #707070;padding:30px 33px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-12faqix-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'\u7B2C' counter(number) '\u6761';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 68339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-rdu7qb-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-rdu7qb-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-rdu7qb-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-rdu7qb-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-rdu7qb-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-rdu7qb-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-rdu7qb-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-rdu7qb-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08\u6CE8' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-rdu7qb-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-rdu7qb-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 31861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CodePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/pages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(68339);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Legal/CodeConduct/CodeItems.tsx





var codeItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C1\u6761\uFF08\u4EBA\u6A29\u306E\u5C0A\u91CD\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\uFF08\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u53CA\u3073\u305D\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\u203B\u3092\u3044\u3046\u3002\uFF09\u306F\u3001\u5404\u56FD\u30FB\u5404\u5730\u57DF\u306E\u6CD5\u4EE4\u7B49\u3092\u8E0F\u307E\u3048\u3001\u4EBA\u6A29\u306B\u95A2\u3059\u308B\u69D8\u3005\u306A\u56FD\u969B\u898F\u7BC4\u3092\u7406\u89E3\u3057\u3001\u57FA\u672C\u7684\u4EBA\u6A29\u3092\u5C0A\u91CD\u3057\u307E\u3059\u3002\u307E\u305F\u3001\u5150\u7AE5\u52B4\u50CD\u3001\u5F37\u5236\u52B4\u50CD\u3092\u8A8D\u3081\u307E\u305B\u3093\u3002", /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u203B\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\u306F", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                path: "/company/overview/",
                text: "\u3053\u3061\u3089"
              }), "\u3067\u3059\u3002"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u304A\u3044\u3066\u3001\u57FA\u672C\u7684\u4EBA\u6A29\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA\u304C\u3042\u3063\u305F\u5834\u5408\u306B\u306F\u3001\u9069\u5207\u306A\u63AA\u7F6E\u3092\u8B1B\u3058\u307E\u3059\u3002\u307E\u305F\u3001\u53D6\u5F15\u5148\u306B\u304A\u3044\u3066\u3082\u3001\u57FA\u672C\u7684\u4EBA\u6A29\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA\u304C\u8A8D\u3081\u3089\u308C\u308B\u5834\u5408\u306F\u3001\u6539\u5584\u3092\u6C42\u3081\u9069\u5207\u306A\u51E6\u7F6E\u3092\u884C\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u4EBA\u6A29\u5C0A\u91CD\u306E\u305F\u3081\u3001\u95A2\u9023\u3059\u308B\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u3068\u5BFE\u8A71\u3092\u9032\u3081\u307E\u3059\u3002"]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u500B\u4EBA\u306E\u57FA\u672C\u7684\u4EBA\u6A29\u3001\u500B\u6027\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u5C0A\u91CD\u3057\u3001\u591A\u69D8\u306A\u4FA1\u5024\u89B3\u3092\u53D7\u5BB9\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u4EBA\u7A2E\u3001\u5B97\u6559\u3001\u6027\u5225\u3001\u56FD\u7C4D\u3001\u5FC3\u8EAB\u969C\u5BB3\u3001\u5E74\u9F62\u3001\u6027\u7684\u6307\u5411\u7B49\u306B\u95A2\u3059\u308B\u5DEE\u5225\u7684\u8A00\u52D5\u3001\u66B4\u529B\u884C\u70BA\u3001\u30BB\u30AF\u30B7\u30E3\u30EB\u30CF\u30E9\u30B9\u30E1\u30F3\u30C8\u3001\u30D1\u30EF\u30FC\u30CF\u30E9\u30B9\u30E1\u30F3\u30C8\u7B49\u306E\u4EBA\u6A29\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA\u3092\u3057\u307E\u305B\u3093\u3002"
          })]
        })]
      })]
    })]
  }),
  id: 'policy1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C2\u6761\uFF08\u304A\u5BA2\u69D8\u306E\u5C0A\u91CD\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u6CD5\u4EE4\u3092\u9075\u5B88\u3057\u3001\u5951\u7D04\u4E8B\u9805\u3092\u5B88\u308B\u3068\u3068\u3082\u306B\u3001\u304A\u5BA2\u69D8\u306B\u6E80\u8DB3\u3044\u305F\u3060\u3051\u308B\u5546\u54C1\u3001\u88FD\u54C1\u3001\u30B7\u30B9\u30C6\u30E0\u3001\u30B5\u30FC\u30D3\u30B9\uFF08\u4EE5\u4E0B\u3001\u300C\u5546\u54C1\u7B49\u300D\u3068\u3044\u3046\uFF09\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5B89\u5168\u3067\u4FE1\u983C\u3055\u308C\u308B\u5546\u54C1\u7B49\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5546\u54C1\u7B49\u306B\u95A2\u3059\u308B\u60C5\u5831\u63D0\u4F9B\u3092\u9069\u5207\u306B\u884C\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u306E\u8981\u671B\u3001\u76F8\u8AC7\u306B\u8AA0\u5B9F\u3001\u8FC5\u901F\u304B\u3064\u7684\u78BA\u306B\u304A\u5FDC\u3048\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u306E\u58F0\u3092\u5927\u5207\u306B\u3057\u3001\u3054\u6E80\u8DB3\u3044\u305F\u3060\u3051\u308B\u5546\u54C1\u7B49\u306E\u54C1\u305E\u308D\u3048\u3001\u4FA1\u683C\u8A2D\u5B9A\u3001\u958B\u767A\u3001\u6539\u5584\u306B\u52AA\u3081\u307E\u3059\u3002"
          })]
        })]
      })]
    })]
  }),
  id: 'policy2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C3\u6761\uFF08\u8CA9\u58F2\u30FB\u751F\u7523\u30FB\u6280\u8853\u6D3B\u52D5\u304A\u3088\u3073\u54C1\u8CEA\u6D3B\u52D5\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u8CA9\u58F2\u30FB\u751F\u7523\u30FB\u6280\u8853\u6D3B\u52D5\u3001\u54C1\u8CEA\u6D3B\u52D5\u306B\u95A2\u4FC2\u3059\u308B\u6CD5\u4EE4\u304A\u3088\u3073\u5951\u7D04\u3092\u9075\u5B88\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u306B\u3054\u6E80\u8DB3\u3044\u305F\u3060\u3051\u308B\u4FA1\u683C\u8A2D\u5B9A\u3001\u4E0D\u65AD\u306E\u6280\u8853\u9769\u65B0\u30FB\u751F\u7523\u6027\u5411\u4E0A\u3092\u56F3\u308A\u3001\u304A\u5BA2\u69D8\u306E\u30CB\u30FC\u30BA\u306B\u57FA\u3065\u3044\u305F\u5B89\u5168\u30FB\u5B89\u5FC3\u3067\u512A\u308C\u305F\u5546\u54C1\u7B49\u3092\u6700\u65B0\u3001\u6700\u826F\u306E\u6280\u8853\u306B\u3088\u308A\u63D0\u4F9B\u3057\u307E\u3059\u3002"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u306E\u7ACB\u5834\u306B\u7ACB\u3063\u3066\u3001\u54C1\u8CEA\u4FDD\u8A3C\u306E\u8CAC\u4EFB\u3092\u679C\u305F\u3057\u3001\u5546\u54C1\u7B49\u306E\u5B89\u5168\u3092\u78BA\u4FDD\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5148\u9032\u7684\u306A\u7814\u7A76\u958B\u767A\u3092\u9032\u3081\u3001\u6280\u8853\u529B\u306E\u5411\u4E0A\u3068\u6280\u8853\u57FA\u76E4\u306E\u6574\u5099\u306B\u52AA\u3081\u307E\u3059\u3002\u307E\u305F\u3001\u84C4\u7A4D\u3055\u308C\u305F\u6280\u8853\u3068\u6280\u80FD\u306E\u7D99\u627F\u306B\u52AA\u3081\u308B\u3068\u3068\u3082\u306B\u3001\u6280\u8853\u74B0\u5883\u306E\u5909\u5316\u306B\u7684\u78BA\u306B\u5BFE\u5FDC\u3057\u3001\u6700\u65B0\u306E\u6280\u8853\u3092\u5546\u54C1\u7B49\u306B\u6D3B\u7528\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5546\u54C1\u7B49\u306B\u95A2\u3059\u308B\u4E8B\u6545\u3084\u5B89\u5168\u306B\u95A2\u3059\u308B\u60C5\u5831\u3092\u5165\u624B\u3057\u305F\u5834\u5408\u3001\u76F4\u3061\u306B\u4E8B\u5B9F\u78BA\u8A8D\u3092\u884C\u3044\u3001\u793E\u5185\u898F\u7A0B\u7B49\u306B\u57FA\u3065\u304D\u3001\u304A\u5BA2\u69D8\u306B\u5FC5\u8981\u306A\u60C5\u5831\u63D0\u4F9B\u3092\u884C\u3046\u3068\u3068\u3082\u306B\u3001\u5546\u54C1\u30FB\u88FD\u54C1\u56DE\u53CE\u3084\u6CE8\u610F\u559A\u8D77\u3001\u8B66\u544A\u8868\u793A\u7B49\u306E\u9069\u5207\u306A\u63AA\u7F6E\u3092\u8B1B\u3058\u307E\u3059\u3002"
          })]
        })]
      })]
    })]
  }),
  id: 'policy3'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C4\u6761\uFF08\u55B6\u696D\u6D3B\u52D5\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u6CD5\u4EE4\u3092\u9075\u5B88\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u6B63\u3057\u3044\u4F01\u696D\u502B\u7406\u306B\u57FA\u3065\u304D\u3001\u516C\u6B63\u306A\u55B6\u696D\u6D3B\u52D5\u3092\u884C\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u306E\u30CB\u30FC\u30BA\u306B\u57FA\u3065\u304D\u3001\u6E80\u8DB3\u3044\u305F\u3060\u3051\u308B\u512A\u308C\u305F\u5546\u54C1\u7B49\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u8AA0\u610F\u3092\u3082\u3063\u3066\u5168\u3066\u306E\u304A\u5BA2\u69D8\u306B\u516C\u6B63\u304B\u3064\u516C\u5E73\u306B\u63A5\u3057\u3001\u9069\u5207\u306A\u6761\u4EF6\u3067\u53D6\u5F15\u3092\u884C\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u6CD5\u4EE4\u3092\u9075\u5B88\u3057\u3001\u5065\u5168\u306A\u5546\u6163\u884C\u3001\u793E\u4F1A\u901A\u5FF5\u306B\u5F93\u3063\u305F\u55B6\u696D\u6D3B\u52D5\u3092\u884C\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u306E\u30CB\u30FC\u30BA\u3092\u7684\u78BA\u306B\u628A\u63E1\u3057\u3001\u6700\u9069\u306A\u5546\u54C1\u7B49\u3092\u63D0\u4F9B\u3067\u304D\u308B\u3088\u3046\u306B\u52AA\u3081\u307E\u3059\u3002"
          })]
        })]
      })]
    })]
  }),
  id: 'policy4'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C5\u6761\uFF08\u72EC\u5360\u7981\u6B62\u6CD5\u30FB\u5B98\u516C\u5E81\u53D6\u5F15\u898F\u5236\u7B49\u306E\u9075\u5B88\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u72EC\u5360\u7981\u6B62\u6CD5\u305D\u306E\u4ED6\u306E\u516C\u6B63\u7AF6\u4E89\u3092\u7DAD\u6301\u3059\u308B\u305F\u3081\u306E\u6CD5\u4EE4\u7B49\uFF08\u4EE5\u4E0B\u3001\u300C\u72EC\u5360\u7981\u6B62\u6CD5\u7B49\u300D\u3068\u3044\u3046\u3002\uFF09\u3092\u9075\u5B88\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5B98\u516C\u5E81\u3068\u306E\u53D6\u5F15\u306B\u3042\u305F\u3063\u3066\u306F\u3001\u6CD5\u4EE4\u304A\u3088\u3073\u5065\u5168\u306A\u5546\u6163\u884C\u3092\u9075\u5B88\u3057\u307E\u3059\u3002"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u6CD5\u4EE4\u9075\u5B88\u306B\u4FC2\u308B\u793E\u5185\u898F\u7A0B\u3092\u9075\u5B88\u3057\u3001\u516C\u6B63\u3067\u81EA\u7531\u306A\u4E8B\u696D\u6D3B\u52D5\u3092\u63A8\u9032\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u304A\u5BA2\u69D8\u304C\u5B98\u516C\u5E81\u306E\u5834\u5408\u306F\u3001\u5B98\u516C\u5E81\u4E8B\u696D\u306B\u4FC2\u308B\u793E\u5185\u898F\u7A0B\u7B49\u3092\u9075\u5B88\u3057\u3001\u5B98\u516C\u5E81\u307E\u305F\u306F\u305D\u306E\u8077\u54E1\uFF08\u5143\u8077\u54E1\u3092\u542B\u307F\u3001\u4EE5\u4E0B\u540C\u3058\u3068\u3059\u308B\u3002\uFF09\u306B\u4E0D\u6B63\u306A\u898B\u7A4D\u984D\u7B49\u3001\u865A\u507D\u306E\u60C5\u5831\u3092\u63D0\u4F9B\u3057\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u4F1A\u5408\u306E\u7D50\u6210\u30FB\u53C2\u52A0\u3001\u7D04\u675F\uFF65\u53D6\u308A\u6C7A\u3081\u3001\u60C5\u5831\u4EA4\u63DB\u7B49\u306E\u9055\u6CD5\u884C\u70BA\u3092\u7591\u308F\u308C\u308B\u3088\u3046\u306A\u884C\u70BA\u3092\u3057\u307E\u305B\u3093\u3002"
          })]
        })]
      })]
    })]
  }),
  id: 'policy5'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C6\u6761\uFF08\u8D08\u8CC4\u306E\u7981\u6B62\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u6CD5\u4EE4\u304A\u3088\u3073\u5065\u5168\u306A\u5546\u6163\u884C\u306B\u53CD\u3057\u305F\u4E0D\u9069\u6B63\u306A\u652F\u51FA\u3092\u884C\u3044\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u653F\u6CBB\u5BB6\u307E\u305F\u306F\u653F\u6CBB\u56E3\u4F53\u306B\u5BFE\u3057\u3001\u4E0D\u9069\u6B63\u306A\u5229\u76CA\u30FB\u4FBF\u5B9C\u3092\u4F9B\u4E0E\u3057\u307E\u305B\u3093\u3002"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5B98\u516C\u5E81\u306E\u8077\u54E1\u3001\u307F\u306A\u3057\u516C\u52D9\u54E1\u3001\u653F\u6CBB\u5BB6\u7B49\uFF08\u5143\u8B70\u54E1\u3001\u79D8\u66F8\u3001\u5143\u79D8\u66F8\u3001\u8B70\u54E1\u5019\u88DC\u8005\u7B49\u3092\u542B\u307F\u3001\u4EE5\u4E0B\u300C\u516C\u52D9\u54E1\u53CA\u3073\u653F\u6CBB\u5BB6\u7B49\u300D\u3068\u3044\u3046\uFF09\u3001\u653F\u6CBB\u56E3\u4F53\u7B49\u306B\u5BFE\u3057\u3001\u6CD5\u4EE4\u304A\u3088\u3073\u5065\u5168\u306A\u5546\u6163\u884C\u306B\u53CD\u3057\u3001\u5831\u916C\u3001\u63A5\u5F85\u3001\u8D08\u7269\u305D\u306E\u4ED6\u3044\u304B\u306A\u308B\u5F62\u614B\u3092\u554F\u308F\u305A\u3001\u307E\u305F\u3001\u76F4\u63A5\u3001\u9593\u63A5\u3092\u554F\u308F\u305A\u3001\u5229\u76CA\u4F9B\u4E0E\u3092\u3057\u307E\u305B\u3093\uFF08\u6CD5\u4EE4\u306B\u9055\u53CD\u305B\u305A\u3001\u304B\u3064\u793E\u4F1A\u7684\u59A5\u5F53\u6027\u304C\u8A8D\u3081\u3089\u308C\u308B\u5834\u5408\u3092\u9664\u304F\uFF09\u3002\u307E\u305F\u3001\u901A\u5E38\u306E\u5546\u6163\u884C\u3088\u308A\u6709\u5229\u306A\u6761\u4EF6\u3067\u306E\u8CA9\u58F2\u304A\u3088\u3073\u8CB8\u4ED8\u7B49\u3092\u884C\u3044\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5B98\u516C\u5E81\u5411\u3051\u55B6\u696D\u306B\u3064\u304D\u3001\u516C\u52D9\u54E1\u53CA\u3073\u653F\u6CBB\u5BB6\u7B49\u672C\u4EBA\u307E\u305F\u306F\u672C\u4EBA\u304C\u95A2\u4FC2\u3059\u308B\u4F1A\u793E\u306B\u5BFE\u3057\u3066\u3082\u3001\u53E3\u92AD\u3001\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u6599\u7B49\u306E\u540D\u76EE\u3092\u554F\u308F\u305A\u3001\u91D1\u92AD\u3092\u652F\u6255\u308F\u305A\u3001\u307E\u305F\u3001\u4FBF\u5B9C\u3092\u4F9B\u4E0E\u3057\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5916\u56FD\u516C\u52D9\u54E1\u7B49\u306B\u5BFE\u3057\u3001\u56FD\u969B\u7684\u306A\u5546\u53D6\u5F15\u306B\u95A2\u3057\u3066\u55B6\u696D\u4E0A\u306E\u4E0D\u6B63\u306E\u5229\u76CA\u3092\u5F97\u308B\u305F\u3081\u306B\u3001\u91D1\u92AD\u305D\u306E\u4ED6\u306E\u5229\u76CA\u3092\u4F9B\u4E0E\u3057\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u4EE3\u7406\u5E97\u7B49\u306E\u7B2C\u4E09\u8005\u306B\u3001\u524D\u8A18\uFF08a\uFF09~\uFF08c\uFF09\u306B\u5B9A\u3081\u308B\u7981\u6B62\u884C\u70BA\u3092\u3055\u305B\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u4EE3\u7406\u5E97\u7B49\u3092\u4F7F\u7528\u3059\u308B\u5834\u5408\u3001\u4E8B\u524D\u306B\u305D\u306E\u5831\u916C\u7B49\u306B\u3064\u304D\u3001\u5408\u7406\u7684\u306B\u53D6\u308A\u6C7A\u3081\u307E\u3059\u3002\u5831\u916C\u306E\u652F\u6255\u306B\u3064\u304D\u6CD5\u4EE4\u4E0A\u306E\u898F\u5236\u304C\u3042\u308B\u3068\u304D\u306B\u306F\u3001\u5F53\u8A72\u6CD5\u4EE4\u306B\u5F93\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u653F\u6CBB\u5BB6\u307E\u305F\u306F\u653F\u6CBB\u56E3\u4F53\u306B\u5BFE\u3057\u3001\u6CD5\u4EE4\u3001\u793E\u5185\u898F\u7A0B\u306B\u53CD\u3057\u305F\u4E0D\u9069\u6B63\u306A\u653F\u6CBB\u5BC4\u4ED8\u7B49\u3092\u884C\u306A\u3044\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u5546\u53D6\u5F15\u4E0A\u306E\u63A5\u5F85\u3001\u8D08\u7269\u3001\u652F\u51FA\u7B49\u3092\u884C\u3046\u5834\u5408\u306F\u3001\u6CD5\u4EE4\u3092\u9075\u5B88\u3057\u307E\u3059\u3002"
          })]
        })]
      })]
    })]
  }),
  id: 'policy6'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C7\u6761\uFF08\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u306E\u6392\u9664\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u57FA\u672C\u65B9\u91DD", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u53CD\u793E\u4F1A\u7684\u52E2\u529B\uFF08\u6CE81\uFF09\u3068\u306E\u53D6\u5F15\u3092\u542B\u3081\u305F\u4E00\u5207\u306E\u95A2\u4FC2\u3092\u906E\u65AD\u3057\u307E\u3059\u3002"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "boldArticle",
        children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5F79\u54E1\u30FB\u5F93\u696D\u54E1\u306E\u884C\u52D5\u57FA\u6E96", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
          marginLeft: "1.5",
          paddingLeft: "0.5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u306B\u3088\u308B\u4E8B\u696D\u6D3B\u52D5\u3078\u306E\u95A2\u4E0E\u3092\u62D2\u7D76\u3057\u307E\u3059\u3002\u307E\u305F\u3001\u305D\u306E\u6D3B\u52D5\u3092\u52A9\u9577\uFF08\u6CE82\uFF09\u3057\u307E\u305B\u3093\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u4E0D\u5F53\u8981\u6C42\uFF08\u6CE83\uFF09\u3092\u53D7\u3051\u305F\u5834\u5408\u306B\u306F\u3001\u6BC5\u7136\u3068\u3057\u305F\u614B\u5EA6\u3067\u8981\u6C42\u3092\u62D2\u5426\u3057\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
            listType: "number",
            children: "\u30DE\u30CD\u30FC\u30FB\u30ED\u30F3\u30C0\u30EA\u30F3\u30B0\uFF08\u72AF\u7F6A\u306B\u3088\u308B\u53CE\u76CA\u306E\u79FB\u8EE2\uFF09\u3092\u898F\u5236\u3059\u308B\u6CD5\u4EE4\u7B49\u3092\u9075\u5B88\u3057\u307E\u3059\u3002"
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "comment",
        children: "\u53CD\u793E\u4F1A\u7684\u52E2\u529B\uFF1A\u66B4\u529B\u3001\u5A01\u529B\u3068\u8A50\u6B3A\u7684\u624B\u6CD5\u3092\u99C6\u4F7F\u3057\u3066\u7D4C\u6E08\u7684\u5229\u76CA\u3092\u8FFD\u6C42\u3059\u308B\u96C6\u56E3\u307E\u305F\u306F\u500B\u4EBA\u306E\u3053\u3068\u3092\u6307\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "comment",
        children: "\u305D\u306E\u6D3B\u52D5\u3092\u52A9\u9577\u3059\u308B\u884C\u70BA\uFF1A\u6A5F\u95A2\u8A8C\u30FB\u66F8\u7C4D\u306E\u8CFC\u8AAD\u3001\u7269\u54C1\u306E\u8CFC\u5165\u3001\u5E83\u544A\u8CDB\u52A9\u3001\u5F79\u52D9\u63D0\u4F9B\u7B49\u53D6\u5F15\u3001\u91D1\u92AD\u30FB\u7269\u54C1\u306E\u4F9B\u4E0E\u3001\u305D\u306E\u4ED6\u306E\u4FBF\u5B9C\u4F9B\u4E0E\u7B49\u306E\u884C\u70BA\u3092\u3044\u3044\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "comment",
        children: "\u4E0D\u5F53\u8981\u6C42\uFF1A\u66B4\u529B\u56E3\u54E1\u306B\u3088\u308B\u3001\u4E8B\u696D\u6D3B\u52D5\u306B\u95A2\u3057\u884C\u308F\u308C\u308B\u66B4\u529B\u7684\u8981\u6C42\u884C\u70BA\u7B49\u3092\u3044\u3044\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy7'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\u5236\u5B9A\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "2022\u5E7412\u670826\u65E5"]
    })
  }),
  id: 'policy8'
}];
var codeLinks = [[{
  name: '（人権の尊重）',
  anchor: 'policy1'
}, {
  name: '（お客様の尊重）',
  anchor: 'policy2'
}, {
  name: '（販売・生産・技術活動および品質活動）',
  anchor: 'policy3'
}, {
  name: '（営業活動）',
  anchor: 'policy4'
}], [{
  name: '（独占禁止法・官公庁取引規制等の遵守）',
  anchor: 'policy5'
}, {
  name: '（贈賄の禁止）',
  anchor: 'policy6'
}, {
  name: '（反社会的勢力の排除）',
  anchor: 'policy7'
}]];
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Legal/Index/index.tsx
var Index = __webpack_require__(99071);
;// CONCATENATED MODULE: ./src/components/pages/Legal/CodeConduct/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var CodePage = function CodePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u884C\u52D5\u898F\u7BC4",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u884C\u52D5\u898F\u7BC4\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'legal/code/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CodeContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
        titleText: "Code of Conduct",
        subTitleText: "\u884C\u52D5\u898F\u7BC4",
        color: "normal"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 64,
        listType: "article",
        links: codeLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 39
        }
      }), codeItems.map(function (_ref, index) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < codeItems.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

CodePage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: '法務'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '法務',
    path: '/legal/'
  }, {
    name: '行動規範',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var CodeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CodeConduct__CodeContainer",
  componentId: "sc-edjz7u-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 68px;}"]);
;// CONCATENATED MODULE: ./src/pages/legal/code.tsx


/***/ }),

/***/ 53335:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/code",
      function () {
        return __webpack_require__(31861);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(53335); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);